export enum MessageType {
  SMS = 'SMS',
  MMS = 'MMS',
}
